import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";

import config from "../../Config";
import { ROUTES } from "../../routes";
import { safeStartViewTransition } from "../../utils/viewTransition";
import useUser from "../../hooks/User";
import SEO from "../../components/SEO";

function OAuthCallback() {
    const nav = useNavigate();
    const [searchParams] = useSearchParams();
    const { error, loading } = useUser();
    
    useEffect(() => {
        // Если уже авторизован, редиректим на профиль
        if (!error && !loading) {
            nav(ROUTES.PROFILE, { viewTransition: true });
            return;
        }
        
        // Получаем токен из query параметров
        const userToken = searchParams.get("user_token");
        const errorParam = searchParams.get("error");
        
        if (errorParam) {
            // Ошибка OAuth, редиректим на страницу входа
            nav(ROUTES.AUTH, { 
                viewTransition: true,
                state: { error: errorParam }
            });
            return;
        }
        
        if (userToken) {
            // Сохраняем токен в cookies
            Cookies.set(config.authCookie, userToken, {
                expires: 30 * 6
            });
            
            // Уведомляем о входе
            window.dispatchEvent(new CustomEvent('user:login'));
            
            // Редиректим на профиль
            safeStartViewTransition(() => {
                nav(ROUTES.PROFILE, { viewTransition: true });
            });
        } else {
            // Токен не получен, редиректим на страницу входа
            nav(ROUTES.AUTH, { viewTransition: true });
        }
    }, [nav, searchParams, error, loading]);
    
    return (
        <>
            <SEO title="Завершение авторизации" description="Завершение процесса авторизации через социальные сети" noindex={true} />
            <div className="auth-page">
            <div className="auth-container">
                <div className="auth-card">
                    <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                        <div style={{ 
                            width: '48px', 
                            height: '48px', 
                            margin: '0 auto 20px',
                            border: '3px solid #2f6fed',
                            borderTopColor: 'transparent',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }}></div>
                        <p style={{ 
                            color: '#4b5b75', 
                            fontSize: '1rem',
                            margin: 0 
                        }}>
                            Завершение авторизации...
                        </p>
                    </div>
                </div>
            </div>
            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
        </>
    );
}

export default OAuthCallback;
